import React from 'react';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { SelectField, SmallBodyText } from '../../../../../ui-toolkit';
import { DisplaySplitClosing } from '../../../../../ui-toolkit/enums/eSplitClosing';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { optionsFromDisplay } from '../../../../../ui-toolkit/enums/optionsFromDisplay';

export const SplitClosing: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();

  return (
    <SummaryItemWithEdit
      label={`Split Closing`}
      tab={`summary`}
      field={`splitClosing`}
      onUpdate={(_, value) => onPatchOrderInformation({ splitClosing: value })}
      order={order}
      editControl={SelectField}
      editProps={{ options: optionsFromDisplay(DisplaySplitClosing), isClearable: false }}
    >
      {order.transaction.splitClosing ? (
        DisplaySplitClosing[order.transaction.splitClosing]
      ) : (
        <SmallBodyText intent={`faded`}>-</SmallBodyText>
      )}
    </SummaryItemWithEdit>
  );
};
